export type ErrorWithCode = {
  code: string;
};

/**
 * Cognito sends back objects with a code property on it that we handle
 */
export const isObjectWithCode = (error: any): error is ErrorWithCode => 'code' in error;
